import { render, staticRenderFns } from "./PercentageDiscount.vue?vue&type=template&id=1803ce1b"
import script from "./PercentageDiscount.vue?vue&type=script&lang=js"
export * from "./PercentageDiscount.vue?vue&type=script&lang=js"
import style0 from "./PercentageDiscount.vue?vue&type=style&index=0&id=1803ce1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports